import * as React from 'react';
export const hostedCheckoutSvg = React.forwardRef(
  function hostedCheckoutSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M10.5 2.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 0 0 .75-.75v-7.5Zm1.5 7.5A2.25 2.25 0 0 1 9.75 12h-7.5A2.25 2.25 0 0 1 0 9.75v-7.5A2.25 2.25 0 0 1 2.25 0h7.5A2.25 2.25 0 0 1 12 2.25v7.5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M6.75 11.25h-1.5V.75h1.5v10.5Z',
      }),
    );
  },
);
hostedCheckoutSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var hostedCheckout = {
  category: 'icon',
  colorable: true,
  name: 'hostedCheckout',
  svg: hostedCheckoutSvg,
};
